import type {
  Club,
  Court,
  Player,
  PointOfSale,
  Product,
  ProductCategory,
} from "@repo/shared-types";
import { useRouteLoaderData } from "react-router";
import { posLayoutId } from "../app/layout";

export const useCurrentPos = () => {
  return useRouteLoaderData(posLayoutId) as {
    pos: PointOfSale;
    club: Club & {
      courts: Court[];
      productCategories: (ProductCategory & {
        products: (Product & { categoryId: string })[];
      })[];
      players: Player[];
    };
  };
};
